module.exports = __webpack_public_path__ + "img/img17.e435c010.png";